module.exports = __webpack_public_path__ + "img/general-bg-7.078fd83a.svg";